import { canUseDOM } from 'exenv';

import loadGATracker from './ga';
import loadFacebookTracker from './facebook';
import loadOmnitureTracker from './omniture';
import loadComscoreTracker from './comscore';
import loadNielsenTracker from './nielsen';
import loadKruxTracker from './krux';
import loadParselyTracker from './parsely';

// The following trackers are executed on CLIENT SIDE ONLY
// Usually during single page app's "pageview" action
export default function trackThirdPartyJS(currentState, pageNumber) {
  if (canUseDOM) {
    const trackers = [
      loadGATracker(currentState, pageNumber),
      loadFacebookTracker(currentState),
      loadOmnitureTracker(currentState, pageNumber),
      loadComscoreTracker(currentState),
      loadNielsenTracker(),
      loadKruxTracker(currentState),
      loadParselyTracker(currentState)
    ];

    return Promise.all(trackers);
  }
  return Promise.resolve([]);
}
